<template>
  <div>
    <InterfaceEdit
      ref="InterfaceEdit"
      :languageOne="languageOne"
      :languageTwo="languageTwo"
      :languageThree="languageThree"
      :languageFour="languageFour"
    />
  </div>
</template>

<script>
import InterfaceEdit from 'components/setting/interface/InterfaceEdit'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'settingInterfaceEdit',
  components: { InterfaceEdit },
  data() {
    return {
      languageOne: [],
      languageTwo: [],
      languageThree: [],
      languageFour: [],
      firstLoadComplete: false,
      languageTemporary: [],
      someKey: 0,
    }
  },
  created() {
    this.firstLoad()
  },
  computed: {
    ...mapGetters('languages', ['languages']),
    ...mapGetters('page', ['pageList']),
    ...mapGetters('interfaceGroup', ['interfaceGroupIdList']),
    ...mapGetters('interfaceAdmin', ['interfaceAdminLanguagesSelect']),
    langSelectOne() {
      return this.interfaceAdminLanguagesSelect[0]
    },
    langSelectTwo() {
      return this.interfaceAdminLanguagesSelect[1]
    },
    langSelectThree() {
      return this.interfaceAdminLanguagesSelect[2]
    },
    langSelectFour() {
      return this.interfaceAdminLanguagesSelect[3]
    },
    interfaceGroupId() {
      return this.$route.meta.interfaceGroupId
    },
  },
  watch: {
    langSelectOne() {
      this.downloadLanguage(this.langSelectOne, 'languageOne')
    },
    langSelectTwo() {
      this.downloadLanguage(this.langSelectTwo, 'languageTwo')
    },
    langSelectThree() {
      this.downloadLanguage(this.langSelectThree, 'languageThree')
    },
    langSelectFour() {
      this.downloadLanguage(this.langSelectFour, 'languageFour')
    },
    languages() {
      this.firstLoad()
    },
    languageOne: {
      deep: true,
      handler() {
        this.onNavigationGuardianCheck({
          data: { languageOne: this.languageOne },
          overwrite: false,
        })
      },
    },
    languageTwo: {
      deep: true,
      handler() {
        this.onNavigationGuardianCheck({
          data: { languageTwo: this.languageTwo },
          overwrite: false,
        })
      },
    },
    languageThree: {
      deep: true,
      handler() {
        this.onNavigationGuardianCheck({
          data: { languageThree: this.languageThree },
          overwrite: false,
        })
      },
    },
    languageFour: {
      deep: true,
      handler() {
        this.onNavigationGuardianCheck({
          data: { languageFour: this.languageFour },
          overwrite: false,
        })
      },
    },

    // languageOne() {
    //   this.checkLanguageFields()
    // },
    // languageTwo() {
    //   this.checkLanguageFields()
    // },
    // languageThree() {
    //   this.checkLanguageFields()
    // },
    // languageFour() {
    //   this.checkLanguageFields()
    // },
  },
  methods: {
    ...mapActions('page', ['onPageList', 'onPageCreate']),
    ...mapActions('interfaceGroup', ['onInterfaceGroupCreate']),
    ...mapActions('interfaceAdmin', ['onInterfaceAdminShow']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    async downloadLanguage(langKey, saveLocal) {
      if (langKey !== undefined) {
        this.onInterfaceAdminShow({
          interface_group_id: this.interfaceGroupId,
          language_id: this.languages[langKey].id,
        }).then(async (resp) => {
          for (let i in resp.data.data) {
            if (this.languageTemporary.indexOf(resp.data.data[i].id) === -1) {
              this.languageTemporary.push(resp.data.data[i].id)
            }
          }
          this[saveLocal] = resp.data.data
          await this.checkLanguageFields()
          this.onNavigationGuardianCheck({
            data: {
              [saveLocal]: this[saveLocal],
            },
            overwrite: true,
          })
        })
      }
    },
    firstLoad() {
      if (Object.keys(this.languages).length && !this.firstLoadComplete) {
        Promise.all([
          this.downloadLanguage(this.langSelectOne, 'languageOne'),
          this.downloadLanguage(this.langSelectTwo, 'languageTwo'),
          this.downloadLanguage(this.langSelectThree, 'languageThree'),
          this.downloadLanguage(this.langSelectFour, 'languageFour'),
        ]).then((response) => {
          if (response) {
            this.firstLoadComplete = true
          }
        })
      }
    },
    checkLanguageFields() {
      console.log('checkLanguageFields')
      let temp = -1
      let local = ['languageOne', 'languageTwo', 'languageThree', 'languageFour']
      for (let loc in local) {
        for (let i in this.languageTemporary) {
          temp = this.languageTemporary[i]
          if (!this[local[loc]].filter((i) => i.id == temp)[0]) {
            this.$set(this[local[loc]], this[local[loc]].length, {
              id: temp,
              value: '',
            })
            // this[local[loc]].push({
            //   id: temp,
            //   value: '',
            // })
          }
        }
      }
    },
  },
  beforeDestroy() {
    this.firstLoadComplete = false
  },
}
</script>

<style lang="scss" scoped></style>
